import http from '~/http/index';

export default ({
  state: {
    data: [],
    additionalData: {},
    filters: {},
    sort: {
      sort: 'referralProgramId',
      sortDesc: true,
    },
    page: 1,
    pages: 0,
    filterLists: {
      levelList: [
        { id: 1, caption: '1 level' },
        { id: 2, caption: '2 level' },
        { id: 3, caption: '3 level' },
        { id: 4, caption: '4 level' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, rootState, rootGetters) {
      const { filters, sort, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const { id } = rootState.user.user;
      const searchString = filters.searchString
        ? filters.searchString.replace('r=', '')
        : null;
      return {
        userIdList: [id],
        ...filters,
        ...sort,
        searchString,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        getTotal: true,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },

    SET_ADDITIONAL_DATA(state, data) {
      state.additionalData = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.post('v2/Referral/GetReferrals', {
        ...getters.requestData,
        ...data,
      });
      const {
        items,
        total,
        cumulativeCurrencyId,
        cumulativeCurrencyTitle,
      } = response.data;
      commit('SET_DATA', items);
      commit('SET_ADDITIONAL_DATA', { cumulativeCurrencyId, cumulativeCurrencyTitle });
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async getReferrals(__store, data) {
      const response = await http.post('v2/Referral/GetReferrals', data);
      return response.data;
    },

    async removeUserFromReferral(__store, data) {
      const response = await http.put('v2/Referral/RemoveUserFromReferral', data);
      return response.data;
    },
  },

  namespaced: true,
});
